import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Feather } from '@expo/vector-icons';

import AppStyles from '../AppStyles';
import { t as translate } from '../i18n';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console in development
    if (__DEV__) {
      console.error('ErrorBoundary caught an error:', error, errorInfo);
    }
    // TODO: In production, send to error reporting service (e.g., Sentry)
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <View style={styles.container}>
          <Feather name="alert-circle" size={64} color={AppStyles.colorSet.brandPrimary} />
          <Text style={styles.title}>{translate('common:error.boundaryTitle')}</Text>
          <Text style={styles.message}>
            {translate('common:error.boundaryMessage')}
          </Text>
          <TouchableOpacity style={styles.button} onPress={this.handleRetry}>
            <Text style={styles.buttonText}>{translate('common:state.tryAgain')}</Text>
          </TouchableOpacity>
          {__DEV__ && this.state.error && (
            <Text style={styles.errorDetails}>{this.state.error.toString()}</Text>
          )}
        </View>
      );
    }

    return this.props.children;
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
    backgroundColor: AppStyles.colorSet.whiteColor,
  },
  title: {
    fontFamily: 'Poppins-SemiBold',
    fontSize: 24,
    color: AppStyles.colorSet.blackColor,
    marginTop: 16,
    marginBottom: 8,
  },
  message: {
    fontFamily: 'Poppins-Regular',
    fontSize: 16,
    color: AppStyles.colorSet.greyColor,
    textAlign: 'center',
    marginBottom: 24,
  },
  button: {
    backgroundColor: AppStyles.colorSet.brandPrimary,
    paddingHorizontal: 32,
    paddingVertical: 12,
    borderRadius: 8,
  },
  buttonText: {
    fontFamily: 'Poppins-Medium',
    fontSize: 16,
    color: AppStyles.colorSet.blackColor,
  },
  errorDetails: {
    fontFamily: 'Poppins-Regular',
    fontSize: 12,
    color: AppStyles.colorSet.greyColor,
    marginTop: 24,
    padding: 12,
    backgroundColor: '#f5f5f5',
    borderRadius: 4,
    maxWidth: '90%',
  },
});

export default ErrorBoundary;
